import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import {
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  GoogleAuthProvider,
} from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDFuyFdeSsGzKz9cfVBxRIdma_O_9wIta8",
  authDomain: "arsenal-center.firebaseapp.com",
  databaseURL: "https://arsenal-center-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "arsenal-center",
  storageBucket: "arsenal-center.appspot.com",
  messagingSenderId: "503474611964",
  appId: "1:503474611964:web:5b0909539c145e495e1979",
  measurementId: "G-B8878QBXG5",
};

// Cloud Functions are deployed to this region (see functions/index.js).
const FUNCTIONS_REGION = "europe-west3";

// Initialize Firebase Auth provider
const provider = new GoogleAuthProvider();

// whenever a user interacts with the provider, we force them to select an account
provider.setCustomParameters({
  prompt: "select_account",
});

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Core services — exported as singletons so the whole app shares one instance.
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, FUNCTIONS_REGION);
export const auth = getAuth(app);

// --- Auth helpers ---------------------------------------------------------
export const signInWithGooglePopup = () => signInWithPopup(auth, provider);
export const signInWithEmail = (email, password) =>
  signInWithEmailAndPassword(auth, email, password);

// Pages historically do `import db from "../../firebase"`, so keep the
// Firestore instance as the default export too (same singleton as `db`).
export default db;
